(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["merryreveal-faq"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('merryreveal-faq')) {
  customElements.define('merryreveal-faq', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const opts = { signal: this.controller.signal };
      this.input = this.querySelector('[data-faq-search]');
      this.items = Array.from(this.querySelectorAll('[data-question]'));
      this.groups = Array.from(this.querySelectorAll('[data-group]'));
      this.links = Array.from(this.querySelectorAll('[data-category-link]'));
      this.status = this.querySelector('[data-status]');
      this.clearButton = this.querySelector('[data-clear]');
      this.empty = this.querySelector('[data-empty]');
      this.querySelector('[data-search-area]').hidden = false;
      this.priorOpen = null;
      this.input.addEventListener('input', () => this.filter(), opts);
      this.clearButton.addEventListener('click', () => { this.input.value = ''; this.filter(); this.input.focus(); }, opts);
      this.input.addEventListener('keydown', event => { if (event.key === 'Escape') { this.input.value = ''; this.filter(); } }, opts);
      this.addEventListener('shopify:block:select', event => {
        const item = event.target.closest('[data-question]');
        if (!item || !this.contains(item)) return;
        this.input.value = ''; this.filter(); item.open = true;
        item.scrollIntoView({ block: 'center' });
      }, opts);
      this.filter();
    }
    disconnectedCallback() { if (this.controller) this.controller.abort(); this.controller = null; }
    filter() {
      const terms = this.input.value.trim().toLocaleLowerCase().split(/\s+/).filter(Boolean);
      if (terms.length && !this.priorOpen) this.priorOpen = new Map(this.items.map(item => [item, item.open]));
      let count = 0;
      for (const item of this.items) {
        const text = item.textContent.toLocaleLowerCase();
        const match = terms.every(term => text.includes(term));
        item.hidden = !match;
        if (match) count++;
        if (terms.length) item.open = match;
        else if (this.priorOpen) item.open = this.priorOpen.get(item) || false;
      }
      if (!terms.length) this.priorOpen = null;
      for (const group of this.groups) {
        group.hidden = !Array.from(group.querySelectorAll('[data-question]')).some(item => !item.hidden);
        const link = this.links.find(link => link.dataset.categoryLink === group.dataset.group);
        if (link) link.hidden = group.hidden;
      }
      this.empty.hidden = count !== 0;
      this.clearButton.hidden = !terms.length;
      this.status.textContent = terms.length ? this.status.dataset.label + ' ' + count : '';
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
